<form [formGroup]="form">
  <div style="margin-top: 50px" formArrayName="privacyList" *ngFor="let item of controls(); let i=index">
    <div [formGroupName]="i">
      <button pButton type="button" class="k-generic-btn" icon="fa fa-minus-circle" iconPos="left"
        label="{{ 'common.delete' | translate }}" (click)="deletePrivacyList(i)">
      </button>
      <div class="ui-g ui-fluid master-data customer-cards-info">
        <p-panel class="ui-g-12 ui-md-12">
          <p-header>
            <div class="ui-helper-clearfix" style="margin-top: 1px">
              <span class="ui-panel-title">
                <h3 style="text-align: center">{{ 'promotion.currentRowNumber' | translate }}: {{rowNumbers[i]}}</h3>
              </span>
            </div>
          </p-header>
          <div class="ui-g-12 ui-fluid">
            <div class="ui-g-12">
              <div>
                <div [kv-form-element]="{ label: 'promotion.rowNumber', md: '2' }">
                  <input type="number" min="0" pInputText formControlName="row_number" />
                </div>
              </div>
              <div class="ui-g-12">
                <p-accordion [multiple]="true">
                  <p-accordionTab header="{{ 'promotion.action' | translate }}">
                    <div style="height: 175px;">
                      <div [kv-form-element]="{ label: 'promotion.action1', md: '4' }">
                        <p-dropdown [options]="actions" formControlName="action_1_pid">
                        </p-dropdown>
                      </div>
                      <div [kv-form-element]="{ label: 'promotion.action2', md: '4' }">
                        <p-dropdown [options]="actions" formControlName="action_2_pid">
                        </p-dropdown>
                      </div>
                      <div [kv-form-element]="{ label: 'promotion.action3', md: '4' }">
                        <p-dropdown [options]="actions" formControlName="action_3_pid">
                        </p-dropdown>
                      </div>
                      <div [kv-form-element]="{ label: 'promotion.action4', md: '4' }">
                        <div style="margin-top: 5px;">
                          <p-dropdown [options]="actions" formControlName="action_4_pid">
                          </p-dropdown>
                        </div>
                      </div>
                      <div [kv-form-element]="{ label: 'promotion.action5', md: '4' }">
                        <div style="margin-top: 5px;">
                          <p-dropdown [options]="actions" formControlName="action_5_pid">
                          </p-dropdown>
                        </div>
                      </div>
                    </div>
                  </p-accordionTab>
                  <p-accordionTab header="{{ 'customerInfoSheet.authorizations' | translate }}">
                    <div style="height: 275px;">
                      <div [kv-form-element]="{ label: 'promotion.prvcTerminal', md: '4' }">
                        <p-inputSwitch formControlName="flg_privacy_terminal"></p-inputSwitch>
                      </div>
                      <div [kv-form-element]="{ label: 'customerDetail.authorization_profiling', md: '4' }">
                        <p-inputSwitch formControlName="flg_privacy_mktg_profiling"></p-inputSwitch>
                      </div>
                      <div [kv-form-element]="{ label: 'customerDetail.authorization_generalcommunications', md: '4' }">
                        <p-inputSwitch formControlName="flg_privacy_generic_comm"></p-inputSwitch>
                      </div>
                      <div [kv-form-element]="{ label: 'customerDetail.authorization_marketingresearch', md: '4' }">
                        <p-inputSwitch formControlName="flg_privacy_mktg_research"></p-inputSwitch>
                      </div>
                      <div [kv-form-element]="{ label: 'customerDetail.authorization_privacy', md: '4' }">
                        <p-inputSwitch formControlName="flg_privacy_auth"></p-inputSwitch>
                      </div>
                      <div [kv-form-element]="{ label: 'customerDetail.authorization_marketingactivity', md: '4' }">
                        <p-inputSwitch formControlName="flg_privacy_mktg_activitiy"></p-inputSwitch>
                      </div>
                      <div
                        [kv-form-element]="{ label: 'customerDetail.authorization_purchasecommunications', md: '4' }">
                        <p-inputSwitch formControlName="flg_privacy_purchase_com"></p-inputSwitch>
                      </div>
                      <div [kv-form-element]="{ label: 'customerDetail.prvcOption', md: '4' }">
                        <p-inputSwitch formControlName="flg_privacy_optin"></p-inputSwitch>
                      </div>
                      <div [kv-form-element]="{ label: 'customerDetail.authorization_newsletter', md: '4' }">
                        <p-inputSwitch formControlName="flg_newsletter"></p-inputSwitch>
                      </div>
                    </div>
                  </p-accordionTab>
                </p-accordion>
              </div>
            </div>
          </div>
        </p-panel>
      </div>
    </div>
  </div>
</form>


// WEBPACK FOOTER //
// ./src/app/views/promotion/touch-point/components/touchPointPrivacyFields.component.html